export default __webpack_public_path__ + "static/media/docusign-long.f463d938.svg";